import { PayloadAction } from "@reduxjs/toolkit";

import { MapState } from "../../types";

export const setRoutePoints = (
  state: MapState,
  action: PayloadAction<MapState['routes']['filter']['routePoints']>
) => {
  state.routes.filter.routePoints = action.payload;
}